// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import svgAnimation from 'svg.js';
import VueCookie from 'vue-cookie';
import VueResource from 'vue-resource';
import vueSmoothScroll from 'vue-smoothscroll';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import inViewportDirective from 'vue-in-viewport-directive';

import textBlow from '@/directives/text-blow';

import App from './App';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Meta);
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(vueSmoothScroll);
Vue.use(VueAwesomeSwiper);
Vue.http.options.root = '/api';

Vue.directive('text-blow', textBlow);
Vue.directive('in-viewport', inViewportDirective);

window.SVG = svgAnimation;

window.Sotbi = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});

window.Sotbi.initMap = () => {
  if (window.Sotbi.$children && window.Sotbi.$children[0]) {
    const sotbiRefs = window.Sotbi.$children[0].$refs;
    if (sotbiRefs && sotbiRefs.mapSotbi && sotbiRefs.mapSotbiDark) {
      sotbiRefs.mapSotbi.initMap();
      sotbiRefs.mapSotbiDark.initMap();
    }
  }
};



// WEBPACK FOOTER //
// ./src/main.js